import { HelpfulVideo } from 'app/components/HelpfulVideo'
import { Container } from 'app/containers/Container'
import { Profile } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import { getBrandHelpers, getBrandInfo } from 'config'
import { IHelpfulVideo } from 'config/interfaces';
import * as _ from 'lodash'
import * as moment from 'moment'
import * as React from 'react'
import { Alert, Button, ButtonGroup, Col, FormGroup, Modal, ModalBody, Panel, Row } from 'react-bootstrap'
import { default as InfiniteCalendar, ReactInfiniteCalendarProps } from 'react-infinite-calendar'
import { Link, Redirect } from 'react-router-dom'
import { isNull } from 'util';

const log = utils.makeDebug(false)

interface IFirstPageContainerState {
  showIntroduction: boolean
  profile: Profile
}

class FirstPage extends Container<{}, IFirstPageContainerState> {
  state: IFirstPageContainerState = {
    showIntroduction: true,
    profile: undefined
  }

  componentWillMount() {
    this.onAppStateUpdate((appState) => {
      const profile = appState.Profile.get('info')

      const profileIsLoaded = !_.isUndefined(profile)
      log('FirstPage.componentWillMount profile is loaded: ' + profileIsLoaded)
      if (profileIsLoaded) {
        const showIntroduction = profile.showIntroduction
        this.setState({ profile, showIntroduction })
      }
    })
  }

  render() {
    const profileIsLoaded = !_.isUndefined(this.state.profile)
    if (!profileIsLoaded) { return null }

    if (this.state.showIntroduction) {
      return (
        <Redirect to="introduction" />
      )
    } else {
      return (
        <Redirect to="dashboard" />
      )
    }
  }

}

export {
  FirstPage
}



// WEBPACK FOOTER //
// ./src/app/containers/FirstPage/index.tsx